var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card-header',{style:(_vm.style),attrs:{"header-bg-variant":_vm.backgroundColor,"header-border-variant":_vm.borderColor,"header-class":_vm.headerClass,"header-text-variant":_vm.textColor}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }